module.exports = __webpack_public_path__ + "img/brand_8.0b6fa68e.png";